import felixHeader from "../../assets/portfolio_assets/felix/header.png";
import felixMain from "../../assets/portfolio_assets/felix/main_photo.png";
import cotravelHeader from "../../assets/portfolio_assets/cotravel/header.png";
import cotravelMain from "../../assets/portfolio_assets/cotravel/main_photo.png";
import crxHeader from "../../assets/portfolio_assets/crx/header.png";
import crxMain from "../../assets/portfolio_assets/crx/main_photo.png";
import debarasariDiverseHeader from "../../assets/portfolio_assets/debarasari_diverse/header.png";
import debarasariDiverseMain from "../../assets/portfolio_assets/debarasari_diverse/main_photo.png";
import demolariInterioareHeader from "../../assets/portfolio_assets/demolari_interioare/header.png";
import demolariInterioareMain from "../../assets/portfolio_assets/demolari_interioare/main_photo.png";
import enamoraWebHeader from "../../assets/portfolio_assets/enamora_web/header.png";
import enamoraWebMain from "../../assets/portfolio_assets/enamora_web/main_photo.png";
import gamebattleHeader from "../../assets/portfolio_assets/gamebattle/header.png";
import gamebattleMain from "../../assets/portfolio_assets/gamebattle/main_photo.png";
import hiveHeader from "../../assets/portfolio_assets/hive/header.png";
import hiveMain from "../../assets/portfolio_assets/hive/main_photo.png";
import krownRomaniaHeader from "../../assets/portfolio_assets/krown_romania/header.png";
import krownRomaniaMain from "../../assets/portfolio_assets/krown_romania/main_photo.png";
import maurisHeader from "../../assets/portfolio_assets/mauris/header.png";
import maurisMain from "../../assets/portfolio_assets/mauris/main_photo.png";
import notchHeader from "../../assets/portfolio_assets/notch/header.png";
import notchMain from "../../assets/portfolio_assets/notch/main_photo.png";
import panelugHeader from "../../assets/portfolio_assets/panelug/header.jpg";
import panelugMain from "../../assets/portfolio_assets/panelug/main_photo.png";
import pokeWebHeader from "../../assets/portfolio_assets/poke_web/header.png";
import pokeWebMain from "../../assets/portfolio_assets/poke_web/main_photo.png";
import remouteHeader from "../../assets/portfolio_assets/remoute/header.png";
import remouteMain from "../../assets/portfolio_assets/remoute/main_photo.png";
import renewHubHeader from "../../assets/portfolio_assets/renew_hub/header.png";
import renewHubMain from "../../assets/portfolio_assets/renew_hub/main_photo.png";
import rhqHeader from "../../assets/portfolio_assets/rhq/header.png";
import rhqMain from "../../assets/portfolio_assets/rhq/main_photo.png";
import rhqcsHeader from "../../assets/portfolio_assets/rhqcs/header.png";
import rhqcsMain from "../../assets/portfolio_assets/rhqcs/main_photo.png";
import rhqWebHeader from "../../assets/portfolio_assets/rhq_web/header.png";
import rhqWebMain from "../../assets/portfolio_assets/rhq_web/main_photo.png";
import transportMolozHeader from "../../assets/portfolio_assets/transport_moloz/header.png";
import transportMolozMain from "../../assets/portfolio_assets/transport_moloz/main_photo.png";
import ugHeader from "../../assets/portfolio_assets/ug/header.jpg";
import ugMain from "../../assets/portfolio_assets/ug/main_photo.png";
import merilusPhoto from "../../assets/ourteampage/member_boxes/member_photos/merilus_photo.png";
import lupusPhoto from "../../assets/ourteampage/member_boxes/member_photos/lupus_photo.png";
import marioPhoto from "../../assets/ourteampage/member_boxes/member_photos/mario_photo.png";
import koruptPhoto from "../../assets/ourteampage/member_boxes/member_photos/korupt_photo.png";
import behanceIcon from "../../assets/homepage/socials/behance.webp";
import instagramIcon from "../../assets/homepage/socials/instagram.webp";
import discordIcon from "../../assets/homepage/socials/discord.webp";

const Projects = [
  {
    id: "felix-branding",
    title: "FELIX",
    subtitle: "BRANDING",
    description:
      "Felix ServDron is a DJI drone service team delivering precise maintenance and repairs across electronics, mechanics, and software. We combine technical rigor and fast turnarounds to keep drones safe, reliable, and mission-ready, handling routine care, troubleshooting, and complex fixes so every flight performs at its best.",
    types: ["BRANDING", "LOGO DESIGN", "BRAND IDENTITY"],
    tools: "Adobe Photoshop, Adobe Illustrator, Figma",
    headerImage: felixHeader,
    projectImages: [felixMain],
    teamMembers: [
      {
        name: "Merila Cosmin",
        role: "Branding Designer",
        photo: merilusPhoto,
      },
    ],
    members: ["Merila Cosmin"],
    socials: [behanceIcon, instagramIcon, discordIcon],
  },
  {
    id: "cotravel-branding",
    title: "COTRAVEL",
    subtitle: "WEB DESIGN / UI UX",
    description: "Project details will be updated soon.",
    types: ["WEB DESIGN", "UI UX"],
    tools: "React, Node js, Figma",
    headerImage: cotravelHeader,
    projectImages: [cotravelMain],
    teamMembers: [
      {
        name: "Pradais Samuel",
        role: "Web Developer",
        photo: lupusPhoto,
      },
    ],
    members: ["Pradais Samuel"],
    socials: [behanceIcon, instagramIcon, discordIcon],
  },
  {
    id: "crx-branding",
    title: "CRX",
    subtitle: "BRANDING",
    description: "Project details will be updated soon.",
    types: ["BRANDING", "LOGO DESIGN", "BRAND IDENTITY"],
    tools: "Adobe Photoshop, Adobe Illustrator, Figma",
    headerImage: crxHeader,
    projectImages: [crxMain],
    teamMembers: [
      {
        name: "Merila Cosmin",
        role: "Branding Designer",
        photo: merilusPhoto,
      },
    ],
    members: ["Merila Cosmin"],
    socials: [behanceIcon, instagramIcon, discordIcon],
  },
  {
    id: "debarasari-diverse-branding",
    title: "DEBARASARI DIVERSE",
    subtitle: "WEB DESIGN / UI UX",
    description: "Project details will be updated soon.",
    types: ["WEB DESIGN", "UI UX"],
    tools: "React, Node js, Figma",
    headerImage: debarasariDiverseHeader,
    projectImages: [debarasariDiverseMain],
    teamMembers: [
      {
        name: "Pradais Samuel",
        role: "Web Developer",
        photo: lupusPhoto,
      },
    ],
    members: ["Pradais Samuel"],
    socials: [behanceIcon, instagramIcon, discordIcon],
  },
  {
    id: "demolari-interioare-branding",
    title: "DEMOLARI INTERIOARE",
    subtitle: "WEB DESIGN / UI UX",
    description: "Project details will be updated soon.",
    types: ["WEB DESIGN", "UI UX"],
    tools: "React, Node js, Figma",
    headerImage: demolariInterioareHeader,
    projectImages: [demolariInterioareMain],
    teamMembers: [
      {
        name: "Pradais Samuel",
        role: "Web Developer",
        photo: lupusPhoto,
      },
    ],
    members: ["Pradais Samuel"],
    socials: [behanceIcon, instagramIcon, discordIcon],
  },
  {
    id: "enamora-web-branding",
    title: "ENAMORA WEB",
    subtitle: "WEB DESIGN / UI UX",
    description: "Project details will be updated soon.",
    types: ["WEB DESIGN", "UI UX"],
    tools: "React, Node js, Figma",
    headerImage: enamoraWebHeader,
    projectImages: [enamoraWebMain],
    teamMembers: [
      {
        name: "Pradais Samuel",
        role: "Web Developer",
        photo: lupusPhoto,
      },
    ],
    members: ["Pradais Samuel"],
    socials: [behanceIcon, instagramIcon, discordIcon],
  },
  {
    id: "gamebattle-branding",
    title: "GAMEBATTLE",
    subtitle: "BRANDING",
    description:
      "GameBattle is a gaming production community helping brands gain engaging exposure while acting as a hub for influencers and young talent. We support Romanian creators with resources, graphic help, and promotion, building a collaborative scene where gamers grow, connect, and evolve together.",
    types: ["BRANDING", "LOGO DESIGN", "BRAND IDENTITY"],
    tools: "Adobe Photoshop, Adobe Illustrator, Figma",
    headerImage: gamebattleHeader,
    projectImages: [gamebattleMain],
    teamMembers: [
      {
        name: "Merila Cosmin",
        role: "Branding Designer",
        photo: merilusPhoto,
      },
    ],
    members: ["Merila Cosmin"],
    socials: [behanceIcon, instagramIcon, discordIcon],
  },
  {
    id: "krown-romania-branding",
    title: "KROWN ROMANIA",
    subtitle: "WEB DESIGN / UI UX",
    description: "Project details will be updated soon.",
    types: ["WEB DESIGN", "UI UX"],
    tools: "React, Node js, Figma",
    headerImage: krownRomaniaHeader,
    projectImages: [krownRomaniaMain],
    teamMembers: [
      {
        name: "Pradais Samuel",
        role: "Web Developer",
        photo: lupusPhoto,
      },
    ],
    members: ["Pradais Samuel"],
    socials: [behanceIcon, instagramIcon, discordIcon],
  },
  {
    id: "hive-branding",
    title: "HIVE",
    subtitle: "BRANDING",
    description:
      "HiveTeam is our portfolio for a collective of developers and designers delivering custom web and mobile apps, brand identity, and specialized gaming servers (FiveM/RedM/RageMP). We are a one-stop, client-focused partner, aligning technology and design to ship cohesive digital experiences that scale for clients and grow communities.",
    types: ["BRANDING", "LOGO DESIGN", "BRAND IDENTITY"],
    tools: "Adobe Photoshop, Adobe Illustrator, Figma",
    headerImage: hiveHeader,
    projectImages: [hiveMain],
    teamMembers: [
      {
        name: "Merila Cosmin",
        role: "Branding Designer",
        photo: merilusPhoto,
      },
    ],
    members: ["Merila Cosmin"],
    socials: [behanceIcon, instagramIcon, discordIcon],
  },
  {
    id: "mauris-branding",
    title: "MAURIS",
    subtitle: "BRANDING",
    description:
      "Mauris.ro is a premium sneaker and streetwear store launched last year. Built on Instagram momentum, it delivers affordable, high-quality fits without the hefty tag. We crafted a seamless, professional experience so customers can browse, buy, and express their style with ease.",
    types: ["BRANDING", "LOGO DESIGN", "BRAND IDENTITY"],
    tools: "Adobe Photoshop, Adobe Illustrator, Figma",
    headerImage: maurisHeader,
    projectImages: [maurisMain],
    teamMembers: [
      {
        name: "Merila Cosmin",
        role: "Branding Designer",
        photo: merilusPhoto,
      },
    ],
    members: ["Merila Cosmin"],
    socials: [behanceIcon, instagramIcon, discordIcon],
  },
  {
    id: "notch-branding",
    title: "NOTCH",
    subtitle: "WEB DESIGN / UI UX",
    description: "Project details will be updated soon.",
    types: ["WEB DESIGN", "UI UX"],
    tools: "React, Node js, Figma",
    headerImage: notchHeader,
    projectImages: [notchMain],
    teamMembers: [
      {
        name: "Pradais Samuel",
        role: "Web Developer",
        photo: lupusPhoto,
      },
    ],
    members: ["Pradais Samuel"],
    socials: [behanceIcon, instagramIcon, discordIcon],
  },
  {
    id: "panelug-branding",
    title: "PANELUG",
    subtitle: "WEB DESIGN / UI UX",
    description:
      "Underground Romania Panel is a FiveM community panel built to simplify server management for players and admins. With an intuitive, ergonomic interface, it streamlines server settings, player management, and key tasks so anyone can operate efficiently without technical overhead.",
    types: ["WEB DESIGN", "UI UX"],
    tools: "React, Node js, Figma",
    headerImage: panelugHeader,
    projectImages: [panelugMain],
    teamMembers: [
      {
        name: "Pradais Samuel",
        role: "Web Developer",
        photo: lupusPhoto,
      },
    ],
    members: ["Pradais Samuel"],
    socials: [behanceIcon, instagramIcon, discordIcon],
  },
  {
    id: "poke-web-branding",
    title: "POKE WEB",
    subtitle: "WEB DESIGN / UI UX",
    description: "Project details will be updated soon.",
    types: ["WEB DESIGN", "UI UX"],
    tools: "React, Node js, Figma",
    headerImage: pokeWebHeader,
    projectImages: [pokeWebMain],
    teamMembers: [
      {
        name: "Pradais Samuel",
        role: "Web Developer",
        photo: lupusPhoto,
      },
    ],
    members: ["Pradais Samuel"],
    socials: [behanceIcon, instagramIcon, discordIcon],
  },
  {
    id: "remoute-branding",
    title: "REMOUTE",
    subtitle: "WEB DESIGN / UI UX",
    description: "Project details will be updated soon.",
    types: ["WEB DESIGN", "UI UX"],
    tools: "React, Node js, Figma",
    headerImage: remouteHeader,
    projectImages: [remouteMain],
    teamMembers: [
      {
        name: "Pradais Samuel",
        role: "Web Developer",
        photo: lupusPhoto,
      },
    ],
    members: ["Pradais Samuel"],
    socials: [behanceIcon, instagramIcon, discordIcon],
  },
  {
    id: "renew-hub-branding",
    title: "RENEW HUB",
    subtitle: "WEB DESIGN / UI UX",
    description: "Project details will be updated soon.",
    types: ["WEB DESIGN", "UI UX"],
    tools: "React, Node js, Figma",
    headerImage: renewHubHeader,
    projectImages: [renewHubMain],
    teamMembers: [
      {
        name: "Pradais Samuel",
        role: "Web Developer",
        photo: lupusPhoto,
      },
    ],
    members: ["Pradais Samuel"],
    socials: [behanceIcon, instagramIcon, discordIcon],
  },
  {
    id: "rhq-branding",
    title: "RHQ",
    subtitle: "BRANDING",
    description:
      "RHQ Network delivers premium hosting with speed, stability, and layered security. With 3-layer DDoS protection, ultra-fast peering (Datacamp, Orange, RCS&RDS, CDN77), and Tier III NXDATA-1 redundancy (N+N/N+1), it provides 100Gbps+ global capacity, minimal latency, and resilient uptime for scalable workloads.",
    types: ["BRANDING", "LOGO DESIGN", "BRAND IDENTITY"],
    tools: "Adobe Photoshop, Adobe Illustrator, Figma",
    headerImage: rhqHeader,
    projectImages: [rhqMain],
    teamMembers: [
      {
        name: "Merila Cosmin",
        role: "Branding Designer",
        photo: merilusPhoto,
      },
    ],
    members: ["Merila Cosmin"],
    socials: [behanceIcon, instagramIcon, discordIcon],
  },
  {
    id: "rhq-web-branding",
    title: "RHQ WEB",
    subtitle: "WEB DESIGN / UI UX",
    description: "Project details will be updated soon.",
    types: ["WEB DESIGN", "UI UX"],
    tools: "React, Node js, Figma",
    headerImage: rhqWebHeader,
    projectImages: [rhqWebMain],
    teamMembers: [
      {
        name: "Pradais Samuel",
        role: "Web Developer",
        photo: lupusPhoto,
      },
    ],
    members: ["Pradais Samuel"],
    socials: [behanceIcon, instagramIcon, discordIcon],
  },
  {
    id: "rhqcs-branding",
    title: "RHQCS",
    subtitle: "BRANDING",
    description:
      "RHQCS was a Counter-Strike 2 competition by RHQ Network, delivering visuals and brand framing for players and fans. We shaped match-ready graphics and event identity to spotlight teams, bracket momentum, and the RHQ hosting brand behind the tournament stage.",
    types: ["BRANDING", "LOGO DESIGN", "BRAND IDENTITY"],
    tools: "Adobe Photoshop, Adobe Illustrator, Figma",
    headerImage: rhqcsHeader,
    projectImages: [rhqcsMain],
    teamMembers: [
      {
        name: "Merila Cosmin",
        role: "Branding Designer",
        photo: merilusPhoto,
      },
    ],
    members: ["Merila Cosmin"],
    socials: [behanceIcon, instagramIcon, discordIcon],
  },
  {
    id: "transport-moloz-branding",
    title: "TRANSPORT MOLOZ",
    subtitle: "WEB DESIGN / UI UX",
    description: "Project details will be updated soon.",
    types: ["WEB DESIGN", "UI UX"],
    tools: "React, Node js, Figma",
    headerImage: transportMolozHeader,
    projectImages: [transportMolozMain],
    teamMembers: [
      {
        name: "Pradais Samuel",
        role: "Web Developer",
        photo: lupusPhoto,
      },
    ],
    members: ["Pradais Samuel"],
    socials: [behanceIcon, instagramIcon, discordIcon],
  },
  {
    id: "ug-branding",
    title: "UG",
    subtitle: "BRANDING",
    description:
      "UG is a FiveM server brand created to deliver a polished, story-driven roleplay world. We built the identity to feel premium and cohesive, matching the in-game experience and the management panel that supports its community.",
    types: ["BRANDING", "LOGO DESIGN", "BRAND IDENTITY"],
    tools: "Adobe Photoshop, Adobe Illustrator, Figma",
    headerImage: ugHeader,
    projectImages: [ugMain],
    teamMembers: [
      {
        name: "Merila Cosmin",
        role: "Branding Designer",
        photo: merilusPhoto,
      },
    ],
    members: ["Merila Cosmin"],
    socials: [behanceIcon, instagramIcon, discordIcon],
  },
];

export default Projects;
